import { useNavigate, useLocation } from "react-router-dom";

export const useQueryParams = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);

  const setParam = (param: string, value: string) => {
    queryParams.set(param, value);
    navigate({ search: queryParams.toString() }, { replace: true });
  };

  const deleteParam = (param: string) => {
    queryParams.delete(param);
    navigate({ search: queryParams.toString() }, { replace: true });
  };

  return { queryParams, deleteParam, setParam };
};
